module.exports = __webpack_public_path__ + "static/img/img-tx2.0afea099.png";